import { useCallback, useEffect, useState } from 'react';
import { apiGet } from '../api/client';

const TWITCH_LOGIN = 'zemaxi';
const POLL_MS = 90_000;

export function useTwitchLive(login = TWITCH_LOGIN) {
  const [status, setStatus] = useState({
    isLive: false,
    streamInfo: null,
    loading: true,
    error: null,
  });

  const fetchLive = useCallback(async () => {
    try {
      const data = await apiGet(`/streamers/live/${encodeURIComponent(login)}`);
      setStatus({
        isLive: Boolean(data.isLive),
        streamInfo: data.streamInfo ?? null,
        loading: false,
        error: data.twitchError ?? null,
      });
    } catch (err) {
      setStatus((prev) => ({
        ...prev,
        loading: false,
        error: err.message,
      }));
    }
  }, [login]);

  useEffect(() => {
    fetchLive();
    const timer = window.setInterval(fetchLive, POLL_MS);
    return () => window.clearInterval(timer);
  }, [fetchLive]);

  return { ...status, refresh: fetchLive };
}
